import { render, staticRenderFns } from "./Pointsshopping.vue?vue&type=template&id=3801aa90&scoped=true&"
import script from "./Pointsshopping.vue?vue&type=script&lang=js&"
export * from "./Pointsshopping.vue?vue&type=script&lang=js&"
import style0 from "./Pointsshopping.vue?vue&type=style&index=0&id=3801aa90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3801aa90",
  null
  
)

export default component.exports